import React from 'react'

const Target = props => (
  <svg width='1em' height='1em' viewBox='-1 -1 20 20' {...props}>
    <path d='M8.2 15.955A7.003 7.003 0 0 1 2.045 9.8H1a.8.8 0 1 1 0-1.6h1.045A7.003 7.003 0 0 1 8.2 2.045V1a.8.8 0 1 1 1.6 0v1.045A7.003 7.003 0 0 1 15.955 8.2H17a.8.8 0 1 1 0 1.6h-1.045A7.003 7.003 0 0 1 9.8 15.955V17a.8.8 0 1 1-1.6 0v-1.045zM9 14.4A5.4 5.4 0 1 0 9 3.6a5.4 5.4 0 0 0 0 10.8zm0-2.2a3.2 3.2 0 1 1 0-6.4 3.2 3.2 0 0 1 0 6.4z' />
  </svg>
)

export default Target
